<template>
  <v-app id="inspire">
    <router-view />
    <div v-if="devBackend" class="dev-backend-badge" data-test="dev-backend-badge">{{ devBackend }} backend</div>
  </v-app>
</template>


<script>
window.LOG_LEVEL = process.env.VUE_APP_LOGGING;

import "@aws-amplify/ui-vue/styles.css";
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";

Amplify.configure(awsconfig);
export default {
  props: {
    source: String,
  },
  // Set only by `npm run serve:staging` (vue.config.js).
  data: () => ({ devBackend: process.env.VUE_APP_DEV_BACKEND || null }),
  async mounted() {
    // Initialize feature flags
    await this.$store.dispatch('initializeApp');

    // Initialize notifications if user is logged in
    if (this.$store.state.user) {
      this.$store.dispatch('notifications/loadNotifications');
      this.$store.dispatch('notifications/loadUnreadCount');
      this.$store.dispatch('notifications/subscribeToNotifications');
    }
  },
};
</script>

<style>
.dev-backend-badge {
  position: fixed;
  left: 12px;
  bottom: 12px;
  z-index: 1000;
  padding: 4px 10px;
  border-radius: 999px;
  background: #B45309;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  pointer-events: none;
}
.theme--light {
  
}
:root {
  --amplify-primary-color: #fb9b6c;
  --amplify-primary-tint: #ff7359;
  --amplify-primary-shade: #e0573e;
}
amplify-authenticator {
  --container-align: top;
}

#hubspot-messages-iframe-container {
  margin-bottom: 2em;
}

.v-step__content {
  text-align: left;
}
</style>